/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */

import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, WIDGET_API, WIDGET_VOTING_SURVEY } from '../../../../../modules/app/Api';
import { makeSelectCookies } from '../../../../../modules/storage/storageSelectors';
import { ECookieKey, ICookies } from '../../../../../modules/storage/storageTypes';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { IWidgetVotingReducer } from './types/widgetVotingTypes';
import { widgetVotingLoadSurveyError, widgetVotingLoadSurveySuccessful } from './widgetVotingActions';

export function* widgetVotingLoadSurveySaga(): SagaIterator {
    try {
        const URL = API_HOSTNAME + WIDGET_API + WIDGET_VOTING_SURVEY;
        const data: IWidgetVotingReducer['data'] = yield call(requestSaga, URL, 'GET');
        const votingUrl = data.url;

        const cookie: ICookies = yield select(makeSelectCookies());
        if (!cookie[ECookieKey.VOTING_HIDE] || decodeURIComponent(cookie[ECookieKey.VOTING_HIDE] + '') !== votingUrl) {
            yield put(widgetVotingLoadSurveySuccessful(data));
        }

    } catch (error: any) {
        yield put(widgetVotingLoadSurveyError({ error }));
    }
}
